// index.jsx
import { Component } from "react";
import { formatDate, getWeekDayList } from "@/utils/func";
import Days from "./days/index";
import './index.less'
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
class Calendar extends Component {
  state = {
    current: formatDate(new Date(this.props.currentView)),
    selectedDate: this.props.selectedDate,
    currentCarouselIndex: 1,
    selectedRange: { start: "", end: "" },
    disabledLeft: true,
    disabledRight: false
  };
  componentWillMount() {
    if (this.props.bindRef) {
      this.props.bindRef(this);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedDate &&
      nextProps.selectedDate !== this.props.selectedDate
    ) {
      this.setState({
        selectedDate: nextProps.selectedDate,
        current: nextProps.selectedDate,
      });
    }
    if (
      nextProps.currentView &&
      nextProps.currentView !== this.props.currentView
    ) {
      this.setState({ current: nextProps.currentView });
    }
  }

  getPickerText = () => {
    const { current } = this.state;
    const currentDateObj = new Date(current);
    return formatDate(currentDateObj)
  };

  onClickDate = (value) => {
    const { onDayClick, onSelectDate } = this.props;
    let { current, currentCarouselIndex, selectedRange } = this.state;
    if (!selectedRange.start || selectedRange.end) {
      selectedRange = { start: value.fullDateStr, end: "" };
    } else {
      if (new Date(selectedRange.start) > new Date(value.fullDateStr)) {
        selectedRange = {
          start: value.fullDateStr,
          end: selectedRange.start,
        };
      } else {
        selectedRange.end = value.fullDateStr;
      }
    }

    this.setState({
      selectedDate: value.fullDateStr,
      selectedRange,
      currentCarouselIndex,
      current,
    });
    if (onDayClick) {
      onDayClick({ value: value.fullDateStr });
    }
    if (onSelectDate) {
      onSelectDate(selectedRange);
    }
  };

  goNext = () => {
    console.log("下个月");
    const { view } = this.props;
    const { currentCarouselIndex } = this.state;
    console.log(this.state.current, 'this.state.current')
    let dateObj = this.state.current;
    console.log(this.state.current, 'this.state.current;')
    const { onClickNext, onCurrentViewChange } = this.props;
    let current = "";
    if (view === "month") {
      // 报错原因是 dateObj 不是 Date 对象，从代码看 this.state.current 可能是格式化后的日期字符串，而非 Date 对象。
      // 需要先将其转换为 Date 对象，再进行月份操作。修改如下：
      dateObj = new Date(dateObj);
      dateObj.setMonth(dateObj.getMonth() + 1);
      const nextMonth = formatDate(dateObj);
      console.log(dateObj, 'dateObj')
      current = nextMonth;
    }
    if (view === "week") {
      dateObj.setDate(dateObj.getDate() + 7);
      const nextWeek = formatDate(dateObj);
      current = nextWeek;
    }
    if (onClickNext) onClickNext();
    if (onCurrentViewChange) onCurrentViewChange(current);
    this.setState({
      currentCarouselIndex: (currentCarouselIndex + 1) % 3,
      current,
    });
  };

  goPre = () => {
    console.log("上个月");
    const { view } = this.props;
    const { currentCarouselIndex } = this.state;
    let dateObj = new Date(this.state.current);
    let current = "";
    if (view === "month") {
      dateObj.setMonth(dateObj.getMonth() - 1);
      const preMonth = formatDate(dateObj);
      current = preMonth;
    }
    if (view === "week") {
      dateObj.setDate(dateObj.getDate() - 7);
      const preWeek = formatDate(dateObj);
      current = preWeek;
    }
    const { onClickPre, onCurrentViewChange } = this.props;
    if (onClickPre) onClickPre();
    if (onCurrentViewChange) onCurrentViewChange(current);
    this.setState({
      currentCarouselIndex: (currentCarouselIndex + 2) % 3,
      current,
    });
  };

  render() {
    const {
      current,
      selectedDate,
      currentCarouselIndex,
      selectedRange,
    } = this.state;
    const {
      marks,
      isVertical,
      selectedDateColor,
      isSwiper,
      minDate,
      maxDate,
      onDayLongPress,
      showDivider,
      isMultiSelect,
      customStyleGenerator,
      headStyle,
      headCellStyle,
      bodyStyle,
      view,
      startDay,
      extraInfo,
    } = this.props;
    // 配合Swiper组件实现无限滚动
    // 原理：永远保持当前屏幕显示月份的左边是前一个月，右边是后一个月
    // current即当前月份，currentCarouselIndex即当前显示页面的index。一共3个页面，index分别为0 1 2 。
    // Swiper的无限循环就是类似0 1 2 0 1 2 这样。如果currentCarouselIndex是2 那么我只要保证 1显示的是前面一个月，0显示的是后面一个月 就完成了循环。
    let currentDate = new Date(current);

    let preDate = new Date(current);
    let nextDate = new Date(current);

    if (view === "month") {
      preDate.setMonth(currentDate.getMonth() - 1);
      nextDate.setMonth(currentDate.getMonth() + 1);
    }
    if (view === "week") {
      preDate.setDate(currentDate.getDate() - 7);
      nextDate.setDate(currentDate.getDate() + 7);
    }
    const preIndex = (currentCarouselIndex + 2) % 3;
    const nextIndex = (currentCarouselIndex + 1) % 3;
    let monthObj = [];
    monthObj[currentCarouselIndex] = currentDate;
    monthObj[preIndex] = preDate;
    monthObj[nextIndex] = nextDate;
    // 所有Days组件的公共Props
    const publicDaysProp = {
      marks: marks || [],
      onClick: this.onClickDate,
      selectedDate,
      minDate: minDate,
      maxDate,
      selectedDateColor,
      onDayLongPress,
      showDivider: showDivider,
      isMultiSelect: isMultiSelect,
      selectedRange: selectedRange,
      customStyleGenerator,
      view: view,
      startDay: startDay,
      extraInfo: extraInfo || [],
    };
    console.log(this.getPickerText())
    return (
      <div className='calendar'>
        <div className='calendar-display'>
          <LeftOutlined style={{
            fontSize: '27px',
            color: this.state.disabledLeft ? '#ccc' : '#999'
          }} onClick={() => {
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;
            const targetYear = Number(this.state.current.split('-')[0]);
            const targetMonth = Number(this.state.current.split('-')[1]);
            this.setState({
              disabledRight: false,
            });
            if (targetYear < currentYear || (targetYear === currentYear && targetMonth <= currentMonth + 1)) {
              this.setState({
                disabledLeft: true,
              });
            }
            if (targetYear < currentYear || (targetYear === currentYear && targetMonth <= currentMonth)) {
              return;
            }

            this.goPre();
          }} />
          <div className="date-text">
            {`${this.state.current.split('-')[0]}年${this.state.current?.split('-')[1]}月`}
          </div>
          <RightOutlined style={{
            fontSize: '27px',
            color: this.state.disabledRight ? '#ccc' : '#999'
          }} onClick={() => {
            console.log(getFirstDayOfCurrentMonth() + 2, '三个月后')
            this.setState({
              disabledLeft: false,
            });
            if (this.state.source === 'tabelog') {
              if (getFirstDayOfCurrentMonth() + 2 <= Number(this.state.current.split('-')[1])) return
            } else {
              const currentYear = new Date().getFullYear();
              const currentMonth = new Date().getMonth() + 1;
              const targetYear = Number(this.state.current.split('-')[0]);
              const targetMonth = Number(this.state.current.split('-')[1]);
              if ((targetYear - currentYear) > 1 || (targetYear - currentYear === 1 && targetMonth >= currentMonth - 1)) {
                console.log('ting')
                this.setState({
                  disabledRight: true,
                });
              }
              if ((targetYear - currentYear) > 1 || (targetYear - currentYear === 1 && targetMonth >= currentMonth)) {
                return;
              }
            }
            this.goNext()
          }} />
        </div>
        <div className="calendar-content">
          <div className='calendar-head' style={headStyle}>
            {getWeekDayList(startDay).map((value) => (
              <div key={value}>
                {value}
              </div>
            ))}

          </div>

          {/* {isSwiper ? (
          <Swiper
            style={{
              height: view === "month" ? "14rem" : "3rem",
              ...bodyStyle,
            }}
            vertical={isVertical}
            circular
            current={currentCarouselIndex}
            onChange={(e) => {
              if (e.detail.source === "touch") {
                const currentIndex = e.detail.current;
                if ((currentCarouselIndex + 1) % 3 === currentIndex) {
                  // 当前月份+1
                  this.goNext();
                } else {
                  // 当前月份-1
                  this.goPre();
                }
              }
            }}
            className='calendar-swiper'
          >
            <SwiperItem style='position: absolute; width: 100%; height: 100%;'>
              <Days date={monthObj[0]} {...publicDaysProp} />
            </SwiperItem>
            <SwiperItem style='position: absolute; width: 100%; height: 100%;'>
              <Days date={monthObj[1]} {...publicDaysProp} />
            </SwiperItem>
            <SwiperItem style='position: absolute; width: 100%; height: 100%;'>
              <Days date={monthObj[2]} {...publicDaysProp} />
            </SwiperItem>
          </Swiper>
        ) : ( */}
          <Days bodyStyle={bodyStyle} date={currentDate} {...publicDaysProp} />
          {/* )} */}
        </div>
      </div>
    );
  }
}
// 获取当前月的第一天
const getFirstDayOfCurrentMonth = () => {
  const today = new Date(); // 当前日期
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1); // 当月第一天
  const month = firstDay.getMonth() + 1// 月份补零
  return month;
};

console.log(getFirstDayOfCurrentMonth(), '获取当前月的第一天')
// 获取三个月后的最后一天
const getLastDayOfThreeMonthsLater = () => {
  const today = new Date(); // 当前日期
  const threeMonthsLater = new Date(today.getFullYear(), today.getMonth() + 3, 1); // 三个月后的第一天
  const lastDay = new Date(threeMonthsLater - 1); // 三个月后的最后一天
  const month = lastDay.getMonth() + 1 // 月份补零
  return month;
};
console.log(getLastDayOfThreeMonthsLater(), '三个月后的第一天')
Calendar.defaultProps = {
  isVertical: false,
  marks: [],
  selectedDate: formatDate(new Date()),
  selectedDateColor: "#90b1ef",
  hideArrow: false,
  isSwiper: true,
  minDate: '2025-03-01',
  maxDate: '2025-05-30',
  showDivider: false,
  isMultiSelect: false,
  view: "month",
  currentView: formatDate(new Date()),
  startDay: 0,
  extraInfo: [],
};
export default Calendar;